import { render, staticRenderFns } from "./game-list.vue?vue&type=template&id=0f96f92f&scoped=true"
import script from "./game-list.vue?vue&type=script&lang=js"
export * from "./game-list.vue?vue&type=script&lang=js"
import style0 from "./game-list.vue?vue&type=style&index=0&id=0f96f92f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96f92f",
  null
  
)

export default component.exports